import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";
import ErroNaTela from "../../components/ErroNaTela";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    height: "100%",
    overflowY: "hidden",
    // respiro em volta: o atendimento vira um "cartão" flutuando sobre o fundo
    padding: 14,
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },

  chatPapper: {
    display: "flex",
    height: "100%",
    overflow: "hidden",
    borderRadius: 18,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(148,163,184,0.14)" : "#e3ece6"}`,
    boxShadow: theme.palette.type === "dark"
      ? "0 12px 40px rgba(0,0,0,0.45)"
      : "0 10px 30px rgba(16,40,28,0.08)",
    animation: "iaSubir .35s ease backwards",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      borderRadius: 0,
      border: "none",
    },
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      minHeight: "100%",
    },
  },
  welcomeMsg: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
    boxShadow: "none",
    borderLeft: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    background: theme.palette.type === "dark"
      ? "radial-gradient(500px 300px at 50% 45%, rgba(34,197,94,0.10), transparent 70%), #101828"
      : "radial-gradient(500px 300px at 50% 45%, rgba(30,152,85,0.08), transparent 70%), #fafcfb",
  },
  welcomeIcone: {
    width: 130,
    animation: "iaFlutuar 4s ease-in-out infinite",
  },
  welcomeTitulo: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  welcomeTexto: {
    fontSize: "0.88rem",
    maxWidth: 320,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0}>
          {}
          <Grid
            item
            xs={12}
            md={4}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <ErroNaTela nome="lista" titulo="Não foi possível carregar a lista de atendimentos">
              <TicketsManager />
            </ErroNaTela>
          </Grid>
          <Grid item xs={12} md={8} className={classes.messagessWrapper}>
            {}
            {ticketId ? (
              <ErroNaTela
                nome="atendimento"
                chave={ticketId}
                titulo="Não foi possível abrir este atendimento"
              >
                <Ticket />
              </ErroNaTela>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* planeta com anel + balão de conversa */}
                  <svg className={classes.welcomeIcone} viewBox="0 0 140 120" aria-hidden="true">
                    <defs>
                      <radialGradient id="welcomePlaneta" cx="35%" cy="30%" r="75%">
                        <stop offset="0" stopColor="#86efac" />
                        <stop offset=".5" stopColor="#22c55e" />
                        <stop offset="1" stopColor="#0f5f35" />
                      </radialGradient>
                    </defs>
                    <circle cx="62" cy="64" r="36" fill="url(#welcomePlaneta)" />
                    <ellipse cx="62" cy="68" rx="58" ry="12" fill="none" stroke="#22c55e" strokeOpacity=".45" strokeWidth="2" transform="rotate(-14 62 68)" />
                    <rect x="88" y="10" width="46" height="30" rx="10" fill="#1E9855" />
                    <path d="M98 40 94 50l12-10z" fill="#1E9855" />
                    <circle cx="101" cy="25" r="3" fill="#fff" />
                    <circle cx="111" cy="25" r="3" fill="#fff" />
                    <circle cx="121" cy="25" r="3" fill="#fff" />
                    <circle cx="16" cy="18" r="2" fill="#22c55e" opacity=".6" />
                    <circle cx="128" cy="92" r="2.5" fill="#22c55e" opacity=".5" />
                    <circle cx="24" cy="104" r="1.8" fill="#22c55e" opacity=".5" />
                  </svg>
                  <div className={classes.welcomeTitulo}>Nenhum atendimento aberto</div>
                  <span className={classes.welcomeTexto}>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
